'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('./util.js');
require('./types.js');
var runtime = require('./runtime.js');



exports.buildProp = runtime.buildProp;
exports.buildProps = runtime.buildProps;
exports.definePropType = runtime.definePropType;
exports.epPropKey = runtime.epPropKey;
exports.isEpProp = runtime.isEpProp;
//# sourceMappingURL=index.js.map
